import { render, staticRenderFns } from "./DarkCircles.vue?vue&type=template&id=6615a37c"
import script from "./DarkCircles.vue?vue&type=script&lang=js"
export * from "./DarkCircles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports